import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent }          from './pages/dashboard/dashboard.component';
import { LoginUnityComponent }         from './login-unity/login-unity.component';
import { InplayComponent }             from './inplay/inplay.component';
import { SportsComponent } from './sports/sports.component';
import { MarketsComponent }            from './markets/markets.component';
import { MarketDetailsComponent }      from './market-details/market-details.component';
import { MarketTabsComponent }         from './market-tabs/market-tabs.component';
import { HorseRacingComponent }        from './horse-racing/horse-racing.component';
import { MultimarketComponent }        from './multimarket/multimarket.component';
import { LivecasinoComponent }         from './livecasino/livecasino.component';
import { VirtualsportsComponent }      from './virtualsports/virtualsports.component';
import { LotteryComponent }            from './lottery/lottery.component';
import { LotteryDetailsComponent }     from './lottery-details/lottery-details.component';
import { AccountComponent }            from './account/account.component';
import { SettingsModuleComponent }     from './settings-module/settings-module.component';
import { BetHistoryComponent }         from './pages/bet-history/bet-history.component';
import { ProfitLossComponent }         from './pages/profit-loss/profit-loss.component';
import { AccountStatementComponent }   from './pages/account-statement/account-statement.component';
import { ActivityLogComponent }        from './pages/activity-log/activity-log.component';
import { PasswordHistoryComponent }    from './pages/password-history/password-history.component';
import { RollingCommissionComponent }  from './pages/rolling-commission/rolling-commission.component';
import { ResultsComponent }            from './results/results.component';
import { TipsAndPreviewsComponent }    from './tips-and-previews/tips-and-previews.component';
import { TipsAndPreviewsDetailsComponent } from './tips-and-previews-details/tips-and-previews-details.component';
import { BallbyballComponent }         from './ballbyball/ballbyball.component';
import { AdminComponent }              from './admin/admin.component';

// Remove HttpClientModule import – it's not needed here
// import { HttpClientModule } from '@angular/common/http';

const routes: Routes = [
  { path: '',        redirectTo: '/home', pathMatch: 'full' },
  { path: 'home',    component: DashboardComponent },
  { path: 'login',   component: LoginUnityComponent },
  { path: 'inplay',  component: InplayComponent },
  { path: 'sports',  component: SportsComponent },
  { path: 'markettabs', component: MarketTabsComponent },
  { path: 'fullMarket/:sportName/:sportId/:eventId',           component: MarketDetailsComponent },
  { path: 'fullMarket/virtual-sports/:sportId/:eventId',       component: MarketDetailsComponent },
  { path: 'horse-racing',                                      component: HorseRacingComponent },
  { path: 'horse-racing/inplayHorseGame/:eventId/:sportId',    component: HorseRacingComponent },
  { path: 'ballByBall/:sportId/:eventId',                      component: BallbyballComponent },
  { path: 'allsport-highlight/:sportId',                       component: MarketsComponent },
  { path: 'multimarket',                                       component: MultimarketComponent },
  { path: 'livecasino',                                        component: LivecasinoComponent },
  { path: 'virtualsports',                                     component: VirtualsportsComponent },
  { path: 'lottery/:sportId/:eventId',                         component: LotteryDetailsComponent },
  { path: 'account',                                           component: AccountComponent },
  { path: 'myprofile',                                         component: AccountComponent },
  { path: 'setting',                                           component: SettingsModuleComponent },
  { path: 'settings',                                          component: SettingsModuleComponent },
  { path: 'bet-history',                                       component: BetHistoryComponent },
  { path: 'profit-loss',                                       component: ProfitLossComponent },
  { path: 'profitloss-event/:sportId/:startDate/:endDate',     component: ProfitLossComponent },
  { path: 'profitloss-market/:eventId/:sportId',               component: ProfitLossComponent },
  { path: 'account-statement',                                 component: AccountStatementComponent },
  { path: 'activity-log',                                      component: ActivityLogComponent },
  { path: 'password-history',                                  component: PasswordHistoryComponent },
  { path: 'rolling-commission',                                component: RollingCommissionComponent },
  { path: 'profit-history/:sportId/:eventId',                  component: ProfitLossComponent },
  { path: 'results',                                           component: ResultsComponent },
  { path: 'tips',                                              component: TipsAndPreviewsComponent },
  { path: 'tips/:id',                                          component: TipsAndPreviewsDetailsComponent },
  { path: 'admin',                                             component: AdminComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }